module.exports = __webpack_public_path__ + "arrow.ac719f4fe8559ad530f69d1d388c4d74.cache.svg";